import Loader from "./AppLoader";
import { useTest } from "../context/TestContext";
import { Outlet, useNavigate } from "react-router-dom";
import AppButton from "./AppButton";
import { ROUTES } from "../routes/config";

export default function TestRoute() {
    const { test, loading, error } = useTest();
    const navigate = useNavigate();

    if (loading) {
        return <Loader fullPage />;
    }

    if (!test) {
        return (
            <div className="mt-10 text-2xl text-red-error w-full h-full grid gap-4 place-content-center">
                <span>{error}</span>
                <AppButton onClick={() => navigate(`/${ROUTES.OPEN_TEST.path}`)}>
                    Go to open test
                </AppButton>
            </div>
        );
    }

    return <Outlet />;
}
